/// <reference path="../../app.definition.ts" />


function clip() {
    return function (text, max) {
        if (_.isNil(text)) return '';
        text = _.clone(text);
        max = parseInt(max, 10);
        if (typeof text != "string" || !max || text.length <= max) {
            return text;
        }
        text = text.substr(0, max);
        return text;
    };
}
angular.module('eCareVault.common.filters').filter('clip', clip);

